import { useMediaQuery } from '@mui/system';
import React from 'react';
import useTargetVsActualFormLogic from 'src/components/VehicleTrackingDetails/TargetVsActualForm/useTargetVsActualFormLogic';
import TargetVsActualFormDesktop from 'src/components/VehicleTrackingDetails/TargetVsActualForm/TargetVsActualFormDesktop';
import TargetVsActualFormMobile from 'src/components/VehicleTrackingDetails/TargetVsActualForm/TargetVsActualFormMobile';

export default function TargetVsActualFormWrapper({
  selectedTargetVsActualConfig,
  toggleTargetVsActualForm,
}) {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const logic = useTargetVsActualFormLogic(selectedTargetVsActualConfig);

  if (isMobile) {
    return (
      <TargetVsActualFormMobile
        selectedTargetVsActualConfig={selectedTargetVsActualConfig}
        toggleTargetVsActualForm={toggleTargetVsActualForm}
        logic={logic}
      />
    );
  }

  return (
    <TargetVsActualFormDesktop
      selectedTargetVsActualConfig={selectedTargetVsActualConfig}
      toggleTargetVsActualForm={toggleTargetVsActualForm}
      logic={logic}
    />
  );
}
